/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementDeletedUserResponse } from "./UserManagementDeletedUserResponse";

export type UserManagementDeletedUserResponseApiRespoonse = {
  data?: UserManagementDeletedUserResponse;
  status?: UserManagementDeletedUserResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementDeletedUserResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
